export const getMealName = (mealType) => {
  const mealMap = {
    1: "Breakfast",
    2: "Dinner",
    3: "Lunch",
  };
  return mealMap[mealType] || "Dinner";
};

export const getLocationName = (location) => {
  const locationMap = {
    1: "Mumbai",
    2: "Noida",
    3: "Mohali",
    4: "Hyderabad",
  };
  return locationMap[location] || "Mumbai";
};
